(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeTagTypeConfigDataStore', [
			'$q',
			'smbContentTypeTagTypeConfigService',
			'smbIndexTypesDataTypes',
			ContentTypeTagTypeConfigDataStore
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypeTagTypeConfigDataStore
	 *
	 * @description
	 * Manages state for index type configuration at the content type level
	 */
	function ContentTypeTagTypeConfigDataStore($q, smbContentTypeTagTypeConfigService, smbIndexTypesDataTypes) {

		var _tagTypes;
		var _contentStatus;
		var _todoStatus;
		var _assignedUserId;
		var _assignedDate;

		return {
			/**
			 * @ngdoc property
			 * @name smbContentTypeTagTypeConfigDataStore#tagTypes
			 * @methodOf smb-app.smbContentTypeTagTypeConfigDataStore
			 * @kind property
			 *
			 * @description
			 * Holds the current collection of tag types for a single content type.
			 *
			 * @returns {TagType[]} A collection of @see TagType objects
			 */
			get tagTypes() { return _tagTypes; },

			/**
			 * @ngdoc method
			 * @name smbContentTypeTagTypeConfigDataStore#getTagTypes,
			 * @methodOf smb-app.smbContentTypeTagTypeConfigDataStore
			 * @kind function
			 *
			 * @description
			 * Gets the tag types for a content type and sets the tagTypes property
			 *
			 * @param {String|Number} id The content type id
			 *
			 * @returns {Promise<TagType[]>} A promise that resolves to a collection of
			 * @see TagType objects
			 */
			getTagTypes: getTagTypes,

			get contentStatus() { return _contentStatus; },

			get todoStatus() { return _todoStatus; },

			get assignedUserId() { return _assignedUserId; },

			get assignedDate() { return _assignedDate; },

			/**
			 * @ngdoc method
			 * @name smbContentTypeTagTypeConfigDataStore#setTagTypes
			 * @methodOf smb-app.smbContentTypeTagTypeConfigDataStore
			 * @kind function
			 *
			 * @description
			 * Sets the tag type associations for a content type. This function
			 * will completely replace the current collection of tag types for a
			 * content type.
			 *
			 * @param {String|Number} id The content type id
			 * @param {TagType[]} tagTypes The tag types to associate the content type with
			 *
			 * @returns {Promise<TagType[]>} A promise that resolves to the tag types given as an argument.
			 */
			setTagTypes: setTagTypes
		};

		function getTagTypes(id) {
			if (!(typeof id === 'number' || typeof id === 'string') || id === '') {
				_tagTypes = [];
				return $q.resolve(_tagTypes);
			}

			return smbContentTypeTagTypeConfigService.getTagTypes(id)
				.then(function(tt) {
					_tagTypes = tt.map(function(tagType) {
						if (tagType.DataType === smbIndexTypesDataTypes.NUMERIC && tagType.Constraints && tagType.Constraints.DefaultValue) {
							tagType.Constraints.DefaultValue = tagType.Constraints.DefaultValue.indexOf('.') >= 0 ?
								parseFloat(tagType.Constraints.DefaultValue) : parseInt(tagType.Constraints.DefaultValue, 10);
						}

						return tagType;
					});

					_contentStatus = _tagTypes.filter(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_Content_Status/);
					});
					_todoStatus = _tagTypes.filter(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_ToDo_Status/);
					});
					_assignedUserId = _tagTypes.filter(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_Assigned_UserId/);
					});
					_assignedDate = _tagTypes.filter(function(tt) {
						return tt.TagTypeName.match(/&&_AirBase_Assigned_Date/);
					});
					return _tagTypes;
				});
		}

		function setTagTypes(id, tagTypes) {
			if (!(typeof id === 'number' || typeof id === 'string')) {
				return $q.reject(new Error('Missing required document type id'));
			} else if (!tagTypes) {
				return $q.reject(new Error('Missing required tag types'));
			}

			var associations = tagTypes.map(function(tt) { return {TagTypeId: tt.TagTypeId, Constraints: tt.Constraints}; });
			return smbContentTypeTagTypeConfigService.setTagTypes(id, associations)
				.then(function() {
					_tagTypes = tagTypes;
					return _tagTypes;
				});
		}
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentConfigDataStores/contentTypeTagTypeConfigDataStore.js
// module id = 110
// module chunks = 1